/**
 * 0から始まる10桁または11桁の半角数字
 * ※carta-features（バックエンド）と同じ条件
 * https://vg-ceg.backlog.com/view/DIGICLUE_LINEMINIAPP-2050#comment-220233557
 */
export const telRegExp = /^0\d{9,10}$/;

/**
 * いちいテナント専用: 全角カタカナのみ許可（半角・全角スペース区切りによる複数名対応）
 * 先頭・末尾・連続スペースは不可
 */
export const katakanaRegExpForIchii = /^[ァ-ヶー]+(?:[ \u3000][ァ-ヶー]+)*$/;

/**
 * いちいテナント専用: 氏名（カナ）入力値の正規化
 * - NFKC正規化（半角カナ→全角など）
 * - ひらがな→カタカナ変換
 * - 連続スペース（半角・全角）を半角スペース1つに統一
 */
export const normalizeKatakanaForIchii = (value: string): string =>
  value
    .normalize('NFKC')
    .replace(/[ぁ-ん]/g, (c) => String.fromCharCode(c.charCodeAt(0) + 0x60))
    .replace(/[ \u3000]+/g, ' ');
